import React from 'react'

export const ReSendEmailSVG = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 -960 960 960" width="30px" fill="#6970E1"><path d="M480-440 160-640v400h360v80H160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v280h-80v-200L480-440Zm0-80 320-200H160l320 200ZM760-40l-56-56 63-64H600v-80h167l-64-64 57-56 160 160L760-40ZM160-640v440-240 3-283 80Z"/></svg>
  )
}
